import { PlayerStates } from 'data/VideoPlayer'
import PlayerWrapperWithPoster from 'components/set/InteractionPlayer/PlayerWrapperWithPoster/PlayerWrapperWithPoster'
import React from 'react'
import WaitAndReload from 'components/common/WaitAndReload/WaitAndReload'

interface LiveStreamErrorProps {
    posterImg: string
    userHasPurchasedTicket: boolean
}

const time: number = 120000

export const LiveStreamError: React.FC<LiveStreamErrorProps> = ({ posterImg, userHasPurchasedTicket }) => {
    if (userHasPurchasedTicket) {
        return (
            <WaitAndReload time={time}>
                <PlayerWrapperWithPoster posterImg={posterImg} stateId={`${PlayerStates.LIVE}_error`} />
            </WaitAndReload>
        )
    }

    return <PlayerWrapperWithPoster posterImg={posterImg} stateId={`${PlayerStates.LIVE}_error`} />
}

export default React.memo(LiveStreamError)
